<template>
    <MainContentSearchable title="Listado de productos" id="productos" v-model="filters" :meta="loading ? {} : productos?.meta" @updated="debouncedGetProductos">
        <template v-slot:header>
            <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                <div class="w-100 mb-3 mb-md-0">
                    <h3 class="card-title pt-2">Listado de productos</h3>
                </div>
                <div class="d-flex flex-column flex-md-row align-items-center justify-content-md-end w-100">
                    <Button 
                        @click="showModal('cargarProductosEventoAnterior')" 
                        class="btn-responsive cargar-btn mb-2 mb-md-0"
                    >
                        Cargar productos de evento anterior
                    </Button>
                    <Button 
                        @click="showModal('addProducto')" 
                        class="btn-responsive mb-2 mb-md-0"
                    >
                        Añadir producto
                    </Button>
                </div>
                <CargarProductosEventoAnterior @cargarProductos="cargarProductosAnterior" />
                <AddProducto v-if="productos" :products="productos.data" @close="closeModal" />
            </div>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <b-row v-if="!loading">
                    <b-col lg="10" md="12" sm="12">
                        <div class="form-group">
                            <label for="products_linked_events">
                                Permitir productos de otros eventos.
                            </label>
                            <multiselect
                                v-model="products_linked_events"
                                placeholder="Seleccione los eventos"
                                label="name"
                                track-by="id"
                                id="products_linked_events"
                                :options="products_events"
                                multiple
                            />
                        </div>                        
                    </b-col>
                    <b-col lg="2" md="12" sm="12" class="align-items-center d-flex justify-content-center">
                        <b-button @click="linkeEvents">
                            Guardar eventos
                        </b-button>
                    </b-col>
                    <b-col cols="12">
                        <div :class="['table', { 'expanded': productos.data?.length <= 3 }]">
                            <b-table hover :items="productos.data" :fields="fields" id="productos-table">
                                <template #cell(precio)="{ item }">
                                    {{ item.precio | formatear_precio }}
                                </template>
                                <template #cell(imagen)="{ item }">
                                    <b-img :src="item.imagen" style="width: 100px; height: 100px;"/>
                                </template>
                                <template #cell(opciones)="{ item, index }">
                                    <OpcionesDropdownTableComponent
                                        :lastIndex="productos.data.length > 3 && index >= productos.data.length - 3"
                                        v-bind:options="[
                                            { type: 'action', action:() => showModal('editar-' + item.id), label: 'Editar'},
                                            { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'}
                                        ]"
                                    />
                                    <ModalEdit 
                                        :name="'editar-' + item.id"
                                        :title="'Editar vínculo producto ' + item.name"
                                        :producto="getProductFormatted(item)"
                                        :products="productos.data"
                                        @close="() => closeModal"
                                        @terminado="editarVinculoProducto"
                                    />
                                    <BorrarModalComponent
                                        :name="'borrar-' + item.id"
                                        :title="'Borrar producto ' + item.name"
                                        confirmButton="¿Está segur@ de borrar este producto?"
                                        @close="() => closeModal"
                                        @confirm="() => borrar(item.id)"
                                    />
                                </template>
                            </b-table>
                        </div>
                    </b-col>
                </b-row>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import AddProducto from '../../modals/AddProducto.vue';
    import ModalEdit from '../../modals/ModalEdit.vue';
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent.vue';
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent.vue';
    import CargarProductosEventoAnterior from '@/components/backend/eventos/sesiones/productos/modals/CargarProductosEventoAnterior.vue';

    export default {
        props: ['evento_id', 'sesion_id'],
        data() {
            return {
                loading: false,
                productos: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [
                    { key: "name", label: "Nombre", class: 'text-center' },
                    { key: "description", label: "Descripción", class: 'text-center' },
                    { key: "precio", label: "Precio", class: 'text-center' },
                    { key: "stock", label: "Stock inicial", class: 'text-center' },
                    { key: "stock_disponible", label: "Stock disponible", class: 'text-center' },
                    { key: "imagen", label: "Imagen", class: 'text-center' },
                    { key: "Opciones", label: "opciones", class: 'text-center' }
                ],
                products_linked_events: [],
                products_events: [],
            }
        },
        created() {
            this.getProductos();
            this.debouncedGetProductos = _.debounce(this.getProductos, 500)
            this.getEvents();
            this.getLinkedEvents();
        },
        methods: {
            getProductos() {
                this.loading = true;

                let params = {
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    filters: this.filters
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesion.productos'), params).then(res => {
                    this.productos = res.data;
                }).finally(() => this.loading = false);
            },
            editarVinculoProducto(producto) {
                this.loading = true;

                let params = {
                    filters: {},
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    product_id: producto.id,
                    producto: {
                        id: producto.id,
                        precio: Number(producto.precio),
                        stock: Number(producto.stock)
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesion.productos.edit'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getProductos();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            },
            borrar(product_id) {
                this.loading = true;

                let params = {
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    product_id: product_id,
                    filters: {
                        tid : this.configuracion.hash_teatro
                    },
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesion.productos.delete'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getProductos();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            },
            cargarProductosAnterior(old_event, old_sesion) {
                this.loading = true;
                
                const params = {
                    filters: {},
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    old_event: old_event.id,
                    old_sesion_id: old_sesion.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesion.productos.copiar'), params).then(res => {
                    this.$toast.success("Productos cargados correctamente!"); 
                    this.getProductos()  
                }).catch(error => {
                    this.$toast.error("No se han podido cargar los productos del evento anterior");
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(actualizar, modal) {
                this.$modal.hide(modal);
                if(actualizar){
                    this.getProductos();
                }
            },
            getProductFormatted(producto) {
                return {
                    id: producto.id,
                    productoSeleccionado: producto,
                    precio: producto.precio,
                    stock: producto.stock
                }
            },
            getEvents() {
                const data = {
                    filters: {
                        to_select: true,
                        with_products: true,
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                    this.products_events = res.data.data;
                });
            },
            getLinkedEvents() {
                const data = {
                    filters: {},
                    evento_id: this.evento_id,
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.get.products.linked.events'), data).then(res => {
                    this.products_linked_events = res.data.data;
                });
            },
            linkeEvents() {
                const data = {
                    filters: {},
                    events: this.products_linked_events.map(event => event.id),
                    evento_id: this.evento_id,
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.sync.products.linked.events'), data).then(res => {
                    this.$toast.success("Eventos vinculados correctamente");
                });
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        components: {
            MainContentSearchable,
            AddProducto,
            BorrarModalComponent,
            OpcionesDropdownTableComponent,
            ModalEdit,
            CargarProductosEventoAnterior       
        }
    }
</script>

<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}

.btn-responsive {
    width: 100%;
}

@media (min-width: 768px) { 
    .btn-responsive {
        width: auto;
    }

    .cargar-btn {
        margin-right: 10px;
    }
}

</style>
